import { render, staticRenderFns } from "./DelDataCom.vue?vue&type=template&id=6d90646d&"
import script from "./DelDataCom.vue?vue&type=script&lang=ts&"
export * from "./DelDataCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports